module.exports = "<div class=\"calendar-schedules\">\n  <!-- Calendar schedules content will be implemented here -->\n</div>\n\n"